import * as React from 'react'

export const IconInfoMsg: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width="16" height="16" x="4" y="4" fill="url(#paint0_linear_23264_15500)" rx="4" />
    <path
      fill="#fff"
      d="M12 10a.667.667 0 1 0 0-1.333A.667.667 0 0 0 12 10M12 10.889c-.4 0-.667.32-.667.8v2.4c0 .48.267.8.667.8s.667-.32.667-.8v-2.4c0-.48-.267-.8-.667-.8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23264_15500"
        x1="12"
        x2="12"
        y1="4"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#768EDD" />
        <stop offset="1" stopColor="#1A42C6" />
      </linearGradient>
    </defs>
  </svg>
)
